export default "__VITE_ASSET__2Xhgp2CQ__"